import React from 'react';

import { Container } from './styles';

interface ModalHomeAlertProps {
  children: React.ReactNode;
}

const ModalHomeAlert: React.FC<ModalHomeAlertProps> = ({ children }) => {
  return (
    <Container>
      {children}
    </Container>
  );
}

export default ModalHomeAlert;
